import { FlightsMinPricesInPeriodParameters } from '@websky/graphql';

export function convertAviaToMinPricesParameters(
	parameters: FlightsMinPricesInPeriodParameters
): FlightsMinPricesInPeriodParameters {
	return {
		...parameters,
		segments: parameters.segments.map(segment => ({
			date: segment.date,
			departure: { iata: segment.departure.iata },
			arrival: { iata: segment.arrival.iata }
		}))
	};
}
